import axios from 'axios'
import {message} from 'ant-design-vue';
message.config({
  duration: 2,
  maxCount: 1,
});

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

let prefix = location.pathname.split("/").slice(0, 2).join("/") + "/api"
let cancel ,promiseArr = {}
const CancelToken = axios.CancelToken;
//请求拦截器
axios.interceptors.request.use(config => {
    //发起请求时，取消掉当前正在进行的相同请求
    // if (promiseArr[config.url]) {
    //     promiseArr[config.url]('操作取消')
    //     promiseArr[config.url] = cancel
    // } else {
    //     promiseArr[config.url] = cancel
    // }
      return config
}, error => {
  return Promise.reject(error)
})

let _Querys = {}
export const addQuery = (id, c)=>{
  _Querys[id] = c
}

export const cancelQuery=(id)=>{
  if(id) {
    delete _Querys[id]
  }
  else {
    Object.keys(_Querys).forEach((uuid)=>{
      _Querys[uuid]()
      delete _Querys[uuid]
    })
  }
}

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
      if(err.response.status == 403 && err.response.data.detail == '未登录, 请登录后访问') {
        window.location.href = `${prefix}/openid/login/?from=${window.location.href}`
        return Promise.reject(err.response)
      }
      switch (err.response.status) {
        case 400:
          err.message = err.response.data.detail || '错误请求'
          break;
        case 401:
          err.message = err.response.data.detail || '未授权，请重新登录'
          break;
        case 403:
          err.message = err.response.data.detail || '拒绝访问'
          break;
        case 404:
          err.message = err.response.data.detail || '请求错误,未找到该资源'
          break;
        case 405:
          err.message = err.response.data.detail || '请求方法未允许'
          break;
        case 408:
          err.message = err.response.data.detail || '请求超时'
          break;
        case 500:
          err.message = err.response.data.detail || '服务器端出错'
          break;
        case 501:
          err.message = err.response.data.detail || '网络未实现'
          break;
        case 502:
          err.message = err.response.data.detail || '网络错误'
          break;
        case 503:
          err.message = err.response.data.detail || '服务不可用'
          break;
        case 504:
          err.message = err.response.data.detail || '网络超时'
          break;
        case 505:
          err.message = err.response.data.detail || 'http版本不支持该请求'
          break;
        default:
          err.message = err.response.data.detail || `连接错误${err.response.status}`
      }
      message.error(err.message)
    } else {
      message.error(err.response.data.detail || err.message || "服务器错误")
    }
    return Promise.reject(err.response)
})

//设置默认请求头
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
}
// axios.defaults.baseURL = '/data/'
//axios.defaults.timeout = 10000

export default {
  //get请求
    get (url, param) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url,
          params: param,
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res.data)
        }).catch(err =>{
          reject(err.data)
        })
      })
    },
    //post请求
    post (url,param, is_query) {
      const uuid = `${String(Math.random()).slice(2)}_${Date.now()}`
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url,
          data: param,
          headers:{
            'Content-Type':'application/json',
          },
          cancelToken: new CancelToken(
            function executor(c) {
              cancel = c
              if(is_query) {
                addQuery(uuid, c)
              }
          })
        }).then(res => {
          resolve(res.data)
          cancelQuery(uuid)
        }).catch(err =>{
          reject(err.data)
          cancelQuery(uuid)
        })
      })
    },
    //put请求
    put (url,param) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'put',
          url,
          data: param,
          headers:{
            'Content-Type':'application/json',
          },
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res.data)
        }).catch(err =>{
          reject(err.data)
        })
      })
    },
    //patch请求
    patch (url,param) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'patch',
          url,
          data: param,
          headers:{
            'Content-Type':'application/json',
          },
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res.data)
        }).catch(err =>{
          reject(err.data)
        })
      })
    },
    //delete请求
    delete (url, param) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'delete',
          url,
          data: param,
          headers:{
            'Content-Type':'application/json',
          },
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res.data)
        }).catch(err =>{
          reject(err.data)
        })
      })
    },
    
    //上传文件请求
    upload (url,param, put) {
      return new Promise((resolve, reject) => {
        axios({
          method: put?'put':'post',
          url,
          data: param,
          headers:{
            'Content-Type':'multipart/form-data;charset=UTF-8',
          },
          cancelToken: new CancelToken(c => {
            cancel = c
          })
        }).then(res => {
          resolve(res.data)
        }).catch(err =>{
          reject(err.data)
        })
      })
    },
    download (url, id, params, self) {
      const uuid = `${String(Math.random()).slice(2)}_${Date.now()}`
      const download = `${id}_${Date.now()}`
      const iframe = document.createElement('iframe')
      iframe.className = 'iiframe'
      iframe.src = `${url}${id}/?download=${download}&search=${JSON.stringify(params)}`
      iframe.onerror = function() {
        message.error('下载出错')
        cancel()
      };
      iframe.onload = function(e) {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        if(doc.getElementsByClassName('response-info')) {
          const text = iframe.contentWindow.document.getElementsByClassName('response-info')[0].innerText
          if(text.indexOf('HTTP 200')<=0) {
            message.error('下载出错')
            cancel()
          }
        }
      };

      document.body.appendChild(iframe)
      let checker
      const cancel = () => {
          clearInterval(checker)
          try {
            document.body.removeChild(iframe)
          }
          catch(e) {

          }
          self.loading = false
      }
      addQuery(uuid, cancel)
      checker = setInterval(() => {
        try {
          if (iframe.contentWindow.document.cookie.indexOf(download) > -1) {
              cancel()
          }
        } catch (e) {
          cancel()
        }
      }, 100)
    }
  }